export default (stringToConvert: string): string => stringToConvert.replace(/\s+/g, '-').toLocaleLowerCase();
